import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e15f6480"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Elimina dipendente", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sei sicuro di voler eliminare questo evento?", -1))
const _hoisted_3 = { class: "central-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalDialog, { type: "modal-alert" }, {
      h3: _withCtx(() => [
        _hoisted_1
      ]),
      h1: _withCtx(() => [
        _hoisted_2
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_PrimaryButton, {
            class: "button bg-white text-primary-900 undo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Annulla")
            ]),
            _: 1
          }),
          _createVNode(_component_PrimaryButton, {
            class: "bg-red-600 text-white",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteEvent()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Elimina")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}